import React from 'react';

/** PHLD.ai — Footer. Minimal: identity, contact, discreet tarasova.fr link. */
export function Footer() {
  const section: React.CSSProperties = { background: 'var(--surface-ink-deep)', color: 'var(--text-on-ink-muted)' };
  const inner: React.CSSProperties = {
    maxWidth: 'var(--container)',
    margin: '0 auto',
    padding: 'var(--space-8) var(--gutter)',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: 'var(--space-6)',
    flexWrap: 'wrap',
  };
  const brand: React.CSSProperties = { display: 'flex', alignItems: 'center', gap: '12px' };
  const word: React.CSSProperties = {
    fontWeight: 'var(--weight-medium)' as any,
    fontSize: '16px',
    letterSpacing: '0.34em',
    color: 'var(--blush)',
    paddingLeft: '4px',
  };
  const tag: React.CSSProperties = { fontSize: 'var(--text-caption)', color: 'var(--text-on-ink-faint)', marginTop: 'var(--space-3)' };
  const right: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--space-2)',
    textAlign: 'right',
    fontSize: 'var(--text-small)',
  };
  const link: React.CSSProperties = { color: 'var(--text-on-ink-muted)', transition: 'color var(--dur-base) var(--ease-out)' };

  return (
    <footer style={section}>
      <div style={inner} className="phld-footer-inner">
        <div>
          <div style={brand}>
            <img src="/assets/brand/phld-mark-blush.svg" alt="" style={{ height: '26px' }} />
            <span style={word}>PHLD</span>
          </div>
          <div style={tag}>Philosophie de Lumière · AI for luxury design, architecture &amp; hospitality · Cannes</div>
        </div>
        <div style={right}>
          <a href="mailto:tarasova@phld.fr" style={link}>
            tarasova@phld.fr
          </a>
          {/* Personal site not live yet — restore when ready.
          <a href="https://tarasova.fr" style={link}>
            tarasova.fr, my personal practice
          </a>
          */}
          <span style={{ color: 'var(--text-on-ink-faint)', fontSize: 'var(--text-caption)' }}>
            © {new Date().getFullYear()} PHLD.ai
          </span>
        </div>
      </div>
    </footer>
  );
}
